import { SegmentDocumentTypeProvider } from 'common/components/provider-documents/interfaces';
import { DeepPartial } from 'redux';

export function getChipSegmentLabel(segment: DeepPartial<SegmentDocumentTypeProvider>) {
    if (segment.externalId) {
        return `${segment.externalId} - ${segment.segmentName}`;
    }
    return segment.segmentName;
}
